import { render, staticRenderFns } from "./AddDeviceRule.vue?vue&type=template&id=08d48fce&scoped=true&"
import script from "./AddDeviceRule.vue?vue&type=script&lang=js&"
export * from "./AddDeviceRule.vue?vue&type=script&lang=js&"
import style0 from "./AddDeviceRule.vue?vue&type=style&index=0&id=08d48fce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d48fce",
  null
  
)

export default component.exports